import type { FeatureFlags as NodeFeatureFlags } from "@fideus/feature-flags/node";
import { z } from "zod/v4";

export const availableFlags = [
  "alwaysOn",
  "showMaintenancePageInClientPortal",
  "showMaintenancePageInServicePortal",
  "showMaintenancePageInTaxAdvisorPortal",
  "enableReactQueryDevTools",
  "enableReactRouterDevTools",
  "allowTriggeringError",
  // Enables the annual statements onboarding flow
  "manageServiceUsers",
  "runServiceScripts",
  "allowDeletingTasks",
  "enableAiDocumentSorting",
  "userManagement",
  // Controls visibility of tax advisor management in service portal
  "manageTaxAdvisors",
  // Controls visibility of structured loan agreement management with interest calculation
  "loanAgreementCalculation",
  // Controls visibility of journal entries / Buchungen in service portal
  "showJournalEntries",
  // Controls the split pricing model: Fideus platform fee (3/4) + tax advisory fee (1/4)
  "softwarePricing",
  // Enables creating all service task types and shows the Jahresabschlüsse page
  "manageProcessErrors",
  // Controls the "Angebot erstellen" feature in service portal
  "createOffer",
  // Controls visibility of billing / Zahlungen in service portal
  "billing",
  // Controls billing features in client portal (subscription guard, checkout)
  "manageBilling",
  // Controls sending disclosure-completed emails when annual statement is disclosed
  "splitDisclosureTasks",
  // Controls disclosure review UI and routes in service portal
  "disclosureReviewInServicePortal",
  // Controls disclosure review UI and routes in tax advisor portal
  "disclosureReviewInTaxAdvisorPortal",
  // Controls automatic scheduling of first reminders when companies or annual statements are created
  "automaticFirstReminders",
  // Controls detailed Vorjahresabschluss upload guidance and Kontennachweis confirmation gate
  "vorjahresabschlussGuidance",
] as const;

export const flagsConfigSchema = z
  // Without a third parameter, the record type interference will fail and assume the first parameter to be values
  .partialRecord(z.enum(availableFlags), z.boolean())
  .describe("Client feature flags")
  .optional();

export type FeatureFlag = (typeof availableFlags)[number];

export type FeatureFlags = NodeFeatureFlags<FeatureFlag>;
